/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getPackages() {
    return axios.get(`${this.url}/packages`);
  }

  getSubmissions() {
    return axios.get(`${this.url}/payment_submissions`);
  }

  createSubmission({
    kind,
    planId,
    credits,
    provider,
    externalRef,
    screenshot,
  }) {
    const formData = new FormData();
    formData.append('kind', kind);
    formData.append('provider', provider);
    if (screenshot) formData.append('screenshot', screenshot);
    if (externalRef) formData.append('external_ref', externalRef);
    if (planId) formData.append('plan_id', planId);
    if (credits) formData.append('credits', credits);

    return axios.post(`${this.url}/payment_submissions`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new BillingAPI();
